<template>
  <v-container style="height: 100%" fluid class="ma-0 pa-0">
    <ShootingStandardHeader :shootingInformations="shootingInformations" :shootingType="shootingType" />
    <v-container style="height: 100%" fluid>
      <v-row class="pa-0" no-gutters>
        <v-col cols="3">
          <ShootingDetailsCard
            :shootingInformations="shootingInformations"
            :totalImages="shooting.length"
            @switchChange="updateSwitchData"
            :createdAt="shootingCreationDate"
            :activeSwitch="isNormalShooting"
            :stamps="shooting.stamps"
          />
        </v-col>
        <v-col cols="7" class="px-2">
          <div v-if="loadingVideoData" class="loader-block">
            <Loader />
          </div>
          <div v-else>
            <div class="column" v-if="this.shootingType === 'VIDEO'">
              <VideoPlayer :video="video" />
            </div>
            <div v-else-if="this.shootingType === 'INSPECTION_REPAIR_ORDER'">
              <ShootingGalleryByOrder :types="types" :images="shooting" />
              <div>
                <VideoPlayer :video="video" />
              </div>
            </div>
            <div v-else>
              <div v-if="shooting.length === 0" class="no-result">{{ $t('shooting.noResults') }}</div>
              <div v-else>
                <div v-if="details">
                  <div v-for="type in types" :key="type">
                    <ShootingGalleryByType :type="type" :images="shootingImages(type)" />
                  </div>
                </div>
                <div v-else>
                  <ShootingGalleryByOrder :types="types" :images="shooting" />
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="2 px-6">
          <ShootingOptions
            :shootingType="shootingType"
            :shootingId="this.$route.params.shootingId"
            :registration="shootingInformations.registration"
            :date="shootingInformations.created"
            :images="shootingImages('ORIGINAL')"
            :details="details"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import Loader from '@/components/Loader.vue'
import ShootingDetailsCard from '@/components/shooting/ShootingDetailsCard.vue'
import ShootingGalleryByOrder from '@/components/shooting/ShootingGalleryByOrder.vue'
import ShootingGalleryByType from '@/components/shooting/ShootingGalleryByType.vue'
import ShootingOptions from '@/components/shooting/ShootingOptions.vue'
import ShootingStandardHeader from '@/components/shooting/ShootingStandardHeader.vue'
import VideoPlayer from '@/components/shooting/VideoPlayer.vue'

export default {
  name: 'Shooting',
  components: {
    Loader,
    ShootingGalleryByType,
    ShootingGalleryByOrder,
    ShootingStandardHeader,
    ShootingOptions,
    VideoPlayer,
    ShootingDetailsCard
  },
  data() {
    return {
      loadingVideoData: true,
      shootingType: null,
      downloadLoading: false,
      loadingReplayDMS: false,
      details: false,
      types: [
        'ORIGINAL',
        'STAMPED',
        'ORIGINAL_LPC',
        'STAMPED_LPC',
        'BACKGROUND_CROPPED',
        'STAMPED_CROPPED',
        'ORIGINAL_CROPPED_LPC',
        'STAMPED_CROPPED_LPC'
      ]
    }
  },
  computed: {
    ...mapGetters({
      shootingInformations: 'shootingInformationFormated'
    }),
    ...mapState({
      shooting: state => state.shooting,
      shootings: state => state.shootings,
      loading: state => state.loading,
      video: state => state.video,
      shootingCreationDate: state => state.shootingCreationDate
    }),
    isNormalShooting() {
      return this.shootingType === 'STANDARD'
    }
  },
  async created() {
    let res
    const ownerId = this.$route.params.ownerId
    const productId = this.$route.params.productId
    const shootingId = this.$route.params.shootingId

    this.defineShootingType()
    this.findShootingInformations(ownerId, productId)

    res = await this.$store.dispatch('getShooting', {
      ownerId: ownerId,
      productId: productId,
      shootingId: shootingId
    })
    if (res) this.loadingVideoData = false
  },
  destroyed() {
    this.$store.commit('RESET_VIDEO')
  },
  methods: {
    defineShootingType() {
      const type = this.$route.path.split('/')[this.$route.path.split('/').length - 1]

      switch (type) {
        case 'inspection-repair-order':
          this.shootingType = 'INSPECTION_REPAIR_ORDER'
          break
        case 'inspect':
          this.shootingType = 'INSPECTION'
          break
        case 'video':
          this.shootingType = 'VIDEO'
          break
        default:
          this.shootingType = 'STANDARD'
      }
    },
    async findShootingInformations(ownerId, productId) {
      const res = await this.$store.dispatch('getShootingsInformations', {
        ownerId: [ownerId],
        productId: productId
      })
    },
    updateSwitchData(value) {
      this.$store.commit('UPDATE_SHOOTING_EDITION_MODE', {
        editionTypeSelected: null,
        isEditMode: false,
        selectedImages: []
      })
      this.details = value
    },
    shootingImages(type) {
      if (!this.shooting) return []
      let list = this.shooting.filter(e => e.imageType === type)
      list = this.orderImages(list)

      return list
    },
    orderImages(list) {
      return list.sort((a, b) => a.order - b.order)
    }
  }
}
</script>

<style lang="sass" scoped>
.loader-block
  width: 100%
  margin: 50px 0
  display: flex
  justify-content: center
</style>
